type ViewingLinkRequester = (
  params: { referralId: string },
  options: {
    onSuccess: (data: { url: string }) => void;
  }
) => void;

export function openMedicalRecords(
  referralId: string,
  requestViewingLink: ViewingLinkRequester
): void {
  requestViewingLink(
    { referralId },
    {
      onSuccess: ({ url }) => {
        const tab = window.open(url, '_blank');
        if (tab) {
          tab.opener = null;
          return;
        }
        window.location.assign(url);
      },
    }
  );
}
